export default {
      id: "ar_annuaire_asso-usage",
      viewBox: "0 0 60 55",
      url: "../dist/images/" + "sprite.svg#ar_annuaire_asso-usage",
      toString: function () {
        return this.url;
      }
    }